import { PurchaseOrder } from "@shared/types";

export const KEEP_CUP_CUSTOMER_ACCOUNT_NUMBER = "CUS41339";

export const BEANZ_DISPLAY_NAME = "Beanz.com";
export const UNKNOWN_CUSTOMER_FALLBACK = "Unknown Customer";
export const UNKNOWN_VENDOR_FALLBACK = "Unknown Vendor";

export const CUSTOMER_LOGO_VARIANTS = {
  BEANZ: "beanz",
  KEEP_CUP: "keep-cup",
} as const;

export type CustomerLogoVariant = (typeof CUSTOMER_LOGO_VARIANTS)[keyof typeof CUSTOMER_LOGO_VARIANTS];

export const getCustomerAccountDisplayName = (purchaseOrder: PurchaseOrder): string => {
  return purchaseOrder.isInternalAccount ? BEANZ_DISPLAY_NAME : (purchaseOrder.customerAccountName ?? UNKNOWN_CUSTOMER_FALLBACK);
};

export const getCustomerLogoVariant = (purchaseOrder: PurchaseOrder): CustomerLogoVariant | undefined => {
  if (purchaseOrder.customerAccountNumber === KEEP_CUP_CUSTOMER_ACCOUNT_NUMBER) {
    return CUSTOMER_LOGO_VARIANTS.KEEP_CUP;
  }
  if (getCustomerAccountDisplayName(purchaseOrder) === BEANZ_DISPLAY_NAME) {
    return CUSTOMER_LOGO_VARIANTS.BEANZ;
  }
  return undefined;
};

export const getVendorName = (purchaseOrder: PurchaseOrder): string => {
  return purchaseOrder.vendorName ?? UNKNOWN_VENDOR_FALLBACK;
};
